import { Swup } from '@hh/global.js'

const swup = new Swup({
  containers: ['.hh-swup'],
  linkSelector: '.js-swup-link',
  timeout: 10000,
})

swup.hooks.on('visit:start', (visit) => {
  visit.scroll.reset = false
})

class MainProductDetails2025 extends HTMLElement {
  constructor() {
    super()
    this.bountAdjustDesktopFormMarginTop =
      this.adjustDesktopFormMarginTop.bind(this)
  }

  connectedCallback() {
    this.connectAppsOnSwupTransition()
    this.adjustDesktopFormMarginTop()
    window.addEventListener('resize', this.bountAdjustDesktopFormMarginTop)
    setTimeout(this.bountAdjustDesktopFormMarginTop, 0)
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.bountAdjustDesktopFormMarginTop)
  }

  connectAppsOnSwupTransition() {
    if (typeof window.yotpo?.initWidgets === 'function') {
      window.yotpo?.initWidgets()
    }

    if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
      window.yotpoWidgetsContainer?.initWidgets()
    }
  }

  adjustDesktopFormMarginTop() {
    const formWrapper = this.querySelector('[data-product-details-content]')
    const heroMedia = this.querySelector('[data-product-details-hero-media]')
    if (!formWrapper || !heroMedia || window.innerWidth < 990) {
      return
    }
    const formWrapperHeight = formWrapper.offsetHeight
    const heroMediaHeight = heroMedia.offsetHeight

    const topMargin = (heroMediaHeight - formWrapperHeight) * 0.5
    const minMarginTop = 16
    formWrapper.style.marginTop = `${Math.max(topMargin, minMarginTop)}px`
  }
}

if (typeof customElements.get('main-product-details-2025') === 'undefined') {
  customElements.define('main-product-details-2025', MainProductDetails2025)
}
